import { and, ControlProps, rankWith, uiTypeIs } from '@jsonforms/core'
import { withJsonFormsControlProps } from '@jsonforms/react'
import { template, templateSettings } from 'lodash'
import { Typography } from 'opensolar-ui'
import * as React from 'react'
import { CSSProperties } from 'react'

const tester = rankWith(100, and(uiTypeIs('OSTypography')))

const Renderer: React.FC<ControlProps> = ({ uischema, data, visible }) => {
  let text = uischema['text']
  let style = uischema['style'] || ({} as CSSProperties)
  const textVariant = uischema['textVariant'] || 'body1'

  if (!visible) return <></>

  if (text?.indexOf('{{') !== -1) {
    if (!data) {
      console.warn('No data found for alert renderer, aborting')
      return <></>
    }

    templateSettings.interpolate = /{{([\s\S]+?)}}/g
    text = template(text)({ data })
  }

  return (
    <Typography textVariant={textVariant} style={style}>
      {text}
    </Typography>
  )
}

const renderer = withJsonFormsControlProps(Renderer)

export default {
  tester,
  renderer,
}
